import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Waves as Desk } from './desk'
import { Waves as Mob } from './mob'

type Props = {
  images: TImages
}
export const Waves: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desk images={images} />
}
